// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-input[data-v-e8881a6e] .v-input__append-inner{margin:0;-ms-flex-item-align:stretch;align-self:stretch}", ""]);
// Exports
module.exports = exports;
